module.exports = __webpack_public_path__ + "img/ic_search_user_1_active.66dda196.svg";